<template >
  <v-layout  row wrap justify-center>
    <v-flex xs12 xl6 lg6 md6>
      <p class="pl-3 mb-0 text--secondary">
        <VisitPersonEditModalV2
          v-model="modals.form"
          :visitPerson="visitPerson"
          @cancelled="onCancel"
          @created="addedPerson"
          @updated="editedPerson"
          :local="true"
          @onOpenImportModal="openImportModal"
          :addText="addText"
        />
      </p>
    </v-flex>
    <Alert
      v-model="modals.confirm"
      title="Correo repetido"
      description="El correo que intentas añadir al invitado externo ya lo tiene otro invitado externo de tu lista, por favor, verifica que sea diferente y corresponda a tu invitado."
    />

    <v-flex xs12 xl6 lg6 md6>
           <v-data-table
        select-all
        :headers="headers"
        :items="people.externs"
        :rows-per-page-items="[5, 10, 50]"
        rows-per-page-text="Registros por página"
        no-results-text="No se encontraron coincidencias"
        no-data-text="Es opcional añadir invitados externos a tu cita, si deseas solo añadir
          invitados internos avanza al siguiente paso."
        ref="collaboratorTable"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :style="{ width: '33%' }"
              style="text-align: left !important"
            >
              {{ header.text }}
            </th>
             <th :style="{ width: '35%' }" style="text-align: left !important">
             
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr
          
          >
            
            <td :style="{ width: '33%' }" style="text-align: left !important">
              {{ props.item.firstName }}
            </td>
            <td :style="{ width: '33%' }" style="text-align: left !important">
              {{ props.item.lastName }}
            </td>
            <td :style="{ width: '33%' }" style="text-align: left !important">
              {{ props.item.email }}
            </td>
            <td   style="width:35%; text-align:left !important;">
             <v-btn @click="removePerson(props.item)" icon>
                <v-icon>delete</v-icon>
              </v-btn>
        
              <v-btn @click="editPerson(props.item, props.item)" icon>
                <v-icon>edit</v-icon>
              </v-btn>

            </td>
          </tr>
        </template>
      </v-data-table>                    
    </v-flex>
    <!-- <v-flex xs4 style="position:relative">
      <v-list subheader two-line dense>
        <div class="info_add_invited" v-if="people.externs.length === 0">
          Es opcional añadir invitados externos a tu cita, si deseas solo añadir
          invitados internos regresa al paso anterior.
        </div>

        <v-subheader style="height: 18px;" v-if="people.externs.length > 0"
          >Invitados externos agregados</v-subheader
        >
        <div class="info_add" v-if="people.externs.length > 0">
          Es opcional añadir invitados internos o externos, pero debes añadir
          alguno de los dos
        </div>

        <template v-for="(item, index) in people.externs">
          <v-list-tile :key="index" avatar>
            <v-list-tile-action style="min-width: 32px;">
              <v-btn @click="removePerson(index)" icon>
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-avatar style="min-width: 32px;">
              <v-btn @click="editPerson(item, index)" icon>
                <v-icon>edit</v-icon>
              </v-btn>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-html="item.firstName + ' ' + item.lastName">
              </v-list-tile-title>
              <v-list-tile-sub-title
                v-html="item.email"
              ></v-list-tile-sub-title>
              <v-divider :key="index" :inset="true"></v-divider>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <p class="pl-3 mb-0 text--secondary" v-if="people.externs.length === 0">
        Aún no hay invitados externos
      </p>
    </v-flex> -->
    <!--<v-flex xs12 md8 mt-4>
      <v-btn
        block
        class="gradiente"
        style="border-radius: 33px"
        dark
        @click="addPerson"
        >Añadir invitado</v-btn>
    </v-flex>-->
    <desition
      @desition="$event ? onDeletePerson() : ''"
      v-model="modals.confirmDeletePerson"
      title="Eliminar invitado"
      description="¿Está seguro que desea realizar dicha acción? Este proceso es irreversible y no podrá recuperar la información"
    />

    <VisitImportModal
      :open="modals.import"
      @close="closeImportModal"
      @importVisitans="importVisitans"
    />

  </v-layout>
</template>

<script>
import { duration } from 'moment'
import desition from '../../Dialogs/Confirm'
import VisitPersonEditModal from './VisitPersonEditModal'
import VisitPersonEditModalV2 from './VisitPersonEditModalV2'
import VisitImportModal from './VisitImportModal'
import Alert from '../../Dialogs/Alert.vue'
import { mapActions } from "vuex"

export default {
  components: {
    desition,
    VisitPersonEditModalV2,
    VisitImportModal,
    Alert,
  },
  props: ['people'],
  data: () => ({
       headers: [
        {
          text: "Nombre",
          value: "firstName",
          width: "33%",
          align: "left",
        },
        { text: "Apellido", value: "lastName", width: "33%", align: "left" },
        { text: "Correo", value: "email", width: "33%", align: "left" },
      ],
    modals: {
      confirmDeletePerson: false,
      form: false,
      confirm: false,
      import: false,
    },
    visitPerson: null,
    personToDeleted: '',
    addText: 'Añadir',
    emailduplicated: [],
    items: [],
    msg: "Hola desde la lista",
     myData: "Dummy Data"
  }),
  computed: {
 
  },
  watch: {},
    mounted(){
        
    },
  methods: {
    ...mapActions(["getIsEmail"]),
    removePerson(index) {
    this.personToDeleted = this.people.externs.indexOf(index)
    this.modals.confirmDeletePerson = true
    console.log(index)
    },
    onDeletePerson() {
      this.people.externs.splice(this.personToDeleted, 1)
      this.personToDeleted = '';
    },
    editPerson(visitPerson, index) {
      this.visitPerson = visitPerson
      this.personToDeleted = this.people.externs.indexOf(index)
      this.modals.form = true
      this.addText = 'Guardar'
      console.log(visitPerson, index);

    },
    editedPerson(_, el) {
      this.$emit('editedPerson', this.personToDeleted, {
        firstName: el.firstName,
        lastName: el.lastName,
        email: el.email,
        phone: el.phone,
      })
        this.people.externs.splice(this.personToDeleted,1, el)
      this.onCancel();
    },
    onClickButton() {
              let arrEmails = []
              // let emailReg = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])$/i;

              this.people.externs.forEach(element => {
                arrEmails.push(element.email)
              }); 

              console.log(arrEmails)
              this.$emit('emailValidate', arrEmails)
              // arrEmails.forEach((adress) =>{
              //    let arrs = emailReg.test(adress);
              //     if( adress === ""){
              //       arrs = true;
              //     }else if(arrs){
                    
              //     this.getIsEmail(true)
              //     }
              //     else{
              //     this.getIsEmail(false)
              //     }
              //     console.log(arrs)
              //   });
    },
    addedPerson(_, el) {
      this.$emit('addedPerson', {
        firstName: el.firstName,
        lastName: el.lastName,
        email: el.email,
        phone: el.phone,
      })
      const copiaobjeto = this.people.externs
      const busqueda = copiaobjeto.reduce((acc, ePeople) => {
        acc[ePeople.email] = ++acc[ePeople.email] || 0
        return acc
      }, {})

      let duplicados = copiaobjeto.filter(ePeople => {
        return busqueda[ePeople.email]
      })
      let dupli = duplicados.filter(item => item.email !== '')
      let sinRepetidos = this.people.externs.filter(
        (valorActual, indiceActual, arreglo) => {
          return (
            arreglo.findIndex(
              valorDelArreglo =>
                JSON.stringify(valorDelArreglo.email) ===
                JSON.stringify(valorActual.email)
            ) === indiceActual
          )
        }
      )
      let sin = sinRepetidos.filter(item => item.email !== '')

      let sinCorreo = this.people.externs.filter(item => item.email === '')

      let todojunto = [...sinCorreo, ...sin]

      let complete = todojunto

      if (el.email.length == 0) {
        // console.log("no se an registrado correos");
        // console.log("estos son los que no tienen correo", sinCorreo)
      } else if (dupli.length == 0) {
        // console.log("ya se registaron con correo y no esta repetido");
        this.people.externs = complete

        // console.log("estos son los que no estan duplicados", sig)
      } else {
        // console.log("ya se registraron con correo pero es repetido");
        this.modals.confirm = true
        this.people.externs = complete
      
      
      }
      
        console.log(this.people.externs)
    },
    openImportModal() {
      this.modals.import = true
    },
    closeImportModal() {
      this.modals.import = false
    },
    importVisitans(visitants) {
      console.log('importVisitans', visitants)
      visitants.forEach(v => {
        console.log(v)
        this.addedPerson(true, v)
       

      })
      console.log('visitants imported')
      this.modals.import = false
    },
        onCancel() {
      this.modals.form = false
      this.personToDeleted = ''
      this.visitPerson = null
      this.addText = 'Añadir', 
      console.log('onCancel', this.addBtnText)
    },
     initialize () {
        this.items = this.people.externs
     },
    
  },
  created() {
     this.initialize()
  },
  mounted(){
    
  }
}
</script>

<style>
.info_add_invited {
  width: 100%;
  height: auto;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 10px;
  margin-left: 16px;
  margin-bottom: 0px;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.info_add {
  width: 100%;
  height: auto;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 10px;
  margin-left: 16px;
  margin-bottom: 0px;
}
</style>
